module.exports = __webpack_public_path__ + "static/media/Brawn.20165d84.svg";